
import {of as observableOf, Observable} from 'rxjs';
import {AbstractExecutionStep} from '../../../../../core/executor/abstract-execution-step';
import {ExecutionStepStatus} from '../../../../../core/executor/execution-step-status';

export class OpenAddressMobilePhoneWindowExecutionStep extends AbstractExecutionStep {

  doExecute(): Observable<ExecutionStepStatus> {
    const payload = this.getPayload(),
      entity = payload.getValue().entity;

    if (!entity) {
      return this.getFailObservable('You need to pass entity as part of Payload value!');
    }

    return this.doOpen(entity);
  }

  private doOpen(entity: {
    mobileCountryCode: string,
    mobileAreaCode: string,
    mobileNumber: string,
    mobileExtension: string
  }): Observable<ExecutionStepStatus> {
    const phoneCountryCode = entity.mobileCountryCode || '',
      phoneAreaCode = entity.mobileAreaCode || '',
      phoneNumber = entity.mobileNumber || '',
      phoneExtension = entity.mobileExtension || '';

    const fullNumber = phoneCountryCode +
      phoneAreaCode +
      phoneNumber +
      phoneExtension;

    document.location.href = `tel:${fullNumber}`;

    return observableOf({status: true, content: null});
  }
}
